import { useEffect } from "react"
import { annotate, annotationGroup } from 'rough-notation';
import Skill from "./assets/Skill";
const TecPage = () => {
    useEffect(()=>{
        const skills = document.querySelector('#skills')
        let scrolling
        let effect2 = false
        window.addEventListener('scroll', ()=>{
            scrolling= document.documentElement.scrollTop || window.scrollY || window.pageYOffset || document.body.scrollTop
            if(scrolling >= skills.offsetTop)
            {
                if(effect2 === false)
                {
                    const e = document.querySelector('#prea')
                    const comp = document.querySelector('#comp')
                    const as1 = annotate(e, {type: 'highlight', color: '#CDFB4D'})
                    const as2 = annotate(comp, {type: 'underline', color: '#d20909'})
                    const ags = annotationGroup([as1,as2])
                    ags.show()
                    effect2 = true
                }
            }
        })
    },[])

    const handleClick = (event) =>{
        console.log(event.target.parentNode)
        if(event.target.parentNode.classList[0] === "skill-title")
        {
            event.target.parentNode.parentNode.classList.toggle('open')
        }else{
            event.target.parentNode.classList.toggle('open')
        }
    }

    return ( 
        <div className="slide" id="skills">
            <div className="wrapper">
                <h2>Maîtrise les technologies clés du web avec notre formation</h2>
                <div className="skills-text">
                En seulement <span>2 ans,</span> <strong id="prea">sans compétence préalable</strong> découvre les technologies les plus utilisées dans le  développement web. Dans un cadre d’apprentissage stimulant et bienveillant, nous t'accompagnons pour que tu deviennes un-e développeur-euse polyvalent-e et <span id="comp">compétent</span>, prêt-e à relever les défis du <span id="pro">monde professionnel.</span>
                </div>
                <div className="epse-skills">
                    <Skill 
                        logo="HTML.svg"
                        title="HTML"
                        content=" <h3>Structure et sémantique du web</h3>
                        <ul>
                            <li>Mise en forme de textes et pages</li>
                            <li>Inclusion de médias (image, vidéo, audio)</li>
                            <li>SEO (balise de sémantiques, meta, schéma markup, etc.)</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="CSS.svg"
                        title="CSS"
                        content=" <h3>Créez des interfaces modernes et responsives</h3>
                        <ul>
                            <li>Positionnement (Flexbox, Grid, ...)</li>    
                            <li>Animations et transformations 3D</li>
                            <li>Gestion du responsive (Media Queries, unités dynamiques)</li>
                            <li>Préprocesseur (SASS) et Frameworks (Bootstrap, Tailwind)</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="svg.svg"
                        title="SVG"
                        content=" <h3>Graphismes vectoriels et animations</h3>
                        <ul>
                            <li>Formes, tracés et dégradés</li>    
                            <li>Animations complexes (Motion, Transform, Morphing, ...)</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="sql.svg"
                        title="SQL"
                        content=" <h3>Gestion des bases de données</h3>
                        <ul>
                            <li>Création et gestion de tables</li>
                            <li>Requête complexes (jointures, fonction SQL)</li>
                            <li>Utilisation de PHPMyAdmin</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="PHP.svg"
                        title="PHP"
                        content=" <h3>Back-end puissant pour des applications dynamiques</h3>
                        <ul>
                            <li>Gestion des formulaires, cookies, sessions</li>
                            <li>Sécurisation des mots de passe</li>
                            <li>Création sous architecture MVC et POO</li>
                            <li>Gestion de la base de données</li>
                            <li>REGEX</li>
                            <li>Récriture d’URL (htaccess)</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="JS.svg"
                        title="JavaScript"
                        content=" <h3>Dynamisme et interactivité</h3>
                        <ul>
                            <li>DOM, gestion des événements</li>
                            <li>Ajax et manipulation de JSON</li>
                            <li>REGEX</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="wordpress.svg"
                        title="CMS"
                        content=" <h3>Création rapide de sites web</h3>
                        <ul>
                            <li>WordPress / WooCommerce</li>
                            <li>PrestaShop</li>
                            <li>Drupal</li>
                            <li>Joomla</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="Symfony.svg"
                        title="Symfony"
                        content=" <h3>Un Framework robuste pour des web app professionnelles</h3>
                        <ul>
                            <li>Développement sous architecture MVC</li>
                            <li>Création d’API performantes</li>
                            <li>Gestion avancée de bases de données avec Doctrine</li>
                            <li>Sécurité des applications (authentification, autorisation, etc)</li>
                            <li>Tests unitaires et fonctionnels</li>
                            <li>Outils intégrés (profiler, gestionnaire de cache)</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="React.svg"
                        title="React / Next"
                        content=" <h3>Créez des interfaces modernes et dynamiques avec des outils puissants</h3>
                        <ul>
                            <li>Composants réactifs pour des interfaces modulaires</li>
                            <li>Gestion de l’état avec des hooks</li>
                            <li>Server-side rendering et Static site generation avec NextJS</li>
                            <li>Routage intégré pour SPA et multipages</li>
                            <li>Optimisation des performances</li>
                            <li>Intégration d’API REST</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="Github.svg"
                        title="Git & GitHub"
                        content=" <h3>Travail collaboratif et gestion de version</h3>
                        <ul>
                            <li>Création de version, de branches, ...</li>
                            <li>Utilisation de GitHub</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="docker.svg"
                        title="Docker"
                        content=" <h3>Un outil incontournable pour développer, tester et déployer en toute simplicité</h3>
                        <ul>
                            <li>Création d’environnements isolés pour vos applications</li>
                            <li>Conteneurisation des projets pour plus de portabilité</li>
                            <li>Gestion des dépendances et configurations spécifiques à chaque projet</li>
                            <li>Utilisation de Docker Compose</li>
                            <li>Automatisation du déploiement avec des images Docker</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="design.svg"
                        title="Design"
                        content=" <h3>Associez code et esthétique</h3>
                        <ul>
                            <li>Bases Adobe Photoshop</li>
                            <li>Bases Adobe Illustrator</li>
                            <li>Création de maquettes avec Figma</li>
                            <li>Création de prototypes avec Figma</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    <Skill 
                        logo="Python.svg"
                        title="Python"
                        content=" <h3>Une introduction d’un programme utilisé dans une multitude de domaines dont le web</h3>
                        <ul>
                            <li>Bases du langage (variables, conditions, boucles, fonctions)</li>
                            <li>Manipulation des structures de données</li>
                            <li>Création de scripts</li>
                            <li>Gestion de fichiers</li>
                            <li>Utilisation des bibliothéques standards</li>
                            <li>Premiers pas en programmation orientée objet (POO)</li>
                        </ul>
                        "
                        handleClick={handleClick}
                    />
                    
                   
                   
               
                </div>
            </div>
        </div>
     );
}
 
export default TecPage;